<div class="modal fade" id="kt_modal_model_code_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Model Code' : 'Add Model Code' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="modelCodeForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Model Dropdown -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Model</label>
              <select
                class="form-select form-select-solid"
                formControlName="model"
                [class.is-invalid]="model?.invalid && model?.touched">
                <option value="">Select Model</option>
                <option *ngFor="let carModel of carModels" [value]="carModel._id">
                  {{ carModel.name }}
                </option>
              </select>
              <div *ngIf="model?.invalid && model?.touched" class="invalid-feedback">
                <div *ngIf="model?.errors?.['required']">Model is required</div>
              </div>
            </div>

            <!-- Code -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Code</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="code"
                placeholder="Enter model code"
                [class.is-invalid]="code?.invalid && code?.touched"
              />
              <div *ngIf="code?.invalid && code?.touched" class="invalid-feedback">
                <div *ngIf="code?.errors?.['required']">Code is required</div>
                <div *ngIf="code?.errors?.['minlength']">Code must be at least 1 character</div>
              </div>
            </div>

            <!-- Length -->
            <div class="col-md-4 mb-5">
              <label class="form-label required">Length</label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control form-control-solid"
                  formControlName="length"
                  placeholder="Enter length"
                  [class.is-invalid]="length?.invalid && length?.touched"
                />
                <span class="input-group-text">cm</span>
              </div>
              <div *ngIf="length?.invalid && length?.touched" class="invalid-feedback">
                <div *ngIf="length?.errors?.['required']">Length is required</div>
                <div *ngIf="length?.errors?.['min']">Length must be greater than or equal to 0</div>
              </div>
            </div>

            <!-- Width -->
            <div class="col-md-4 mb-5">
              <label class="form-label required">Width</label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control form-control-solid"
                  formControlName="width"
                  placeholder="Enter width"
                  [class.is-invalid]="width?.invalid && width?.touched"
                />
                <span class="input-group-text">cm</span>
              </div>
              <div *ngIf="width?.invalid && width?.touched" class="invalid-feedback">
                <div *ngIf="width?.errors?.['required']">Width is required</div>
                <div *ngIf="width?.errors?.['min']">Width must be greater than or equal to 0</div>
              </div>
            </div>

            <!-- Height -->
            <div class="col-md-4 mb-5">
              <label class="form-label required">Height</label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control form-control-solid"
                  formControlName="height"
                  placeholder="Enter height"
                  [class.is-invalid]="height?.invalid && height?.touched"
                />
                <span class="input-group-text">cm</span>
              </div>
              <div *ngIf="height?.invalid && height?.touched" class="invalid-feedback">
                <div *ngIf="height?.errors?.['required']">Height is required</div>
                <div *ngIf="height?.errors?.['min']">Height must be greater than or equal to 0</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
